import React, { useEffect } from 'react'
import { Container, Row, Spinner } from 'react-bootstrap'
import BrandCard from './BrandCard'
import SubTitle from '../Layout/SubTitle'

const BrandContainer = ({ allBrands }) => {
  return (
    <>
      <div className='gray-bg mt-3'>
        <Container>
          <SubTitle title="All Brands" />
        </Container>
      </div>
      <Container className='mh-100-exact'>
        {allBrands && allBrands.length >= 1 ? (
          <>
            <Row className='my-5 d-flex'>
              {allBrands ? (allBrands.map((item, index) => {
                let imageUrl = item.image;
                if (imageUrl.startsWith('http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/')) {
                  imageUrl = imageUrl.replace('http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/', '');
                }
                else if (imageUrl.startsWith('http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/')) {
                  imageUrl = imageUrl.replace('http://127.0.0.1:8000/brands/', '');
                }
                else if (imageUrl.startsWith('http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/')) {
                  imageUrl = imageUrl.replace('http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/http://127.0.0.1:8000/brands/', '');
                }
                else {
                  imageUrl = item.image;
                }
                return (<BrandCard key={index} img={imageUrl} cardText={item.name} />)
              })) : (<h2 className='text-center mh-100-exact d-flex align-items-center justify-content-center'>No Brands to Show</h2>)}

            </Row>
          </>
        ) : (<div className='d-flex justify-content-center align-items-center mt-5 pt-5'>
          <Spinner animation="border" variant="danger" />
        </div>)}
      </Container>
    </>

  )
}

export default BrandContainer
